module.exports = __webpack_public_path__ + "media/images/japan/arrow_2-0c56afc972ddeb2611ec5beb9f666ad8.svg";